export const buildTimeInputValueOnHourChange = (currentValue: string, hour12: string, dayTime: 'AM' | 'PM'): string => {
  const minutes = currentValue.split(':')[1] ?? '00';
  let hours24 = hour12;

  if (hour12 === '12' && dayTime === 'AM') {
    hours24 = '00';
  } else if (hour12 === '12' && dayTime === 'PM') {
    hours24 = '12';
  } else if (dayTime === 'PM') {
    hours24 = `${parseInt(hour12, 10) + 12}`;
  }

  return `${hours24}:${minutes}`;
};
